// extracted by mini-css-extract-plugin
export default {"ClientDetail":"ClientDetail_ClientDetail__IMTyX","tableResponsive":"ClientDetail_tableResponsive__pjF7f"};